import { useEffect, useState } from 'react';

interface OutlookHostInfo {
  isInitialized: boolean;
  hostType: 'OutlookWeb' | 'OutlookDesktopOld' | 'OutlookDesktopNew' | 'Unknown';
  engine: 'IE11' | 'WebView2' | 'Chromium' | 'WebKit' | 'Unknown';
  diagnosticsVersion: string | null;
  userAgent: string;
}

export function useOutlookHostInfo(): OutlookHostInfo {
  const [info, setInfo] = useState<OutlookHostInfo>({
    isInitialized: false,
    hostType: 'Unknown',
    engine: 'Unknown',
    diagnosticsVersion: null,
    userAgent: typeof navigator === 'undefined' ? '' : navigator.userAgent,
  });

  useEffect(() => {
    if (!Office?.context) return;

    const ua = navigator.userAgent;
    const diagnosticsVersion = Office.context.diagnostics?.version || null;

    let engine: OutlookHostInfo['engine'] = 'Unknown';
    if (/Trident|MSIE/.test(ua)) engine = 'IE11';
    else if (/Edg\//.test(ua)) engine = 'WebView2';
    else if (/Chrome\//.test(ua)) engine = 'Chromium';
    else if (/Safari\//.test(ua) && !/Chrome\//.test(ua)) engine = 'WebKit';

    let hostType: OutlookHostInfo['hostType'] = 'Unknown';

    if (Office.context.platform === Office.PlatformType.OfficeOnline) {
      hostType = 'OutlookWeb';
    } else if (diagnosticsVersion === '0.0.0.0') {
      hostType = 'OutlookDesktopNew'; // WebView2
    } else if (diagnosticsVersion && diagnosticsVersion !== '0.0.0.0') {
      hostType = 'OutlookDesktopOld'; // IE11-based
    }

    setInfo({
      isInitialized: true,
      hostType,
      engine,
      diagnosticsVersion,
      userAgent: ua,
    });
  }, []);

  return info;
}
